import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from '@/components/AppShell'
import { AuthProvider } from '@/features/auth/AuthProvider'
import { LoginPage } from '@/features/auth/LoginPage'
import { RequireAdmin } from '@/features/auth/RequireAdmin'
import { CategoriesPage } from '@/pages/CategoriesPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { FeedbackPage } from '@/pages/FeedbackPage'
import { InconsistenciesPage } from '@/pages/InconsistenciesPage'
import { MaterialsPage } from '@/pages/MaterialsPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { RulesPage } from '@/pages/RulesPage'
import { SetupScreen } from '@/pages/SetupScreen'
import { UnitsPage } from '@/pages/UnitsPage'
import { UsersPage } from '@/pages/UsersPage'
import { firebaseConfigErrors, isFirebaseReady } from '@/lib/firebase'

// Firestore listeners already push updates, so queries do not need to refetch on focus.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1, staleTime: 30_000 },
  },
})

export function App() {
  if (!isFirebaseReady) {
    return <SetupScreen missing={firebaseConfigErrors} />
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <RequireAdmin>
                  <AppShell />
                </RequireAdmin>
              }
            >
              <Route path="/" element={<DashboardPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/feedback" element={<FeedbackPage />} />
              <Route path="/materials" element={<MaterialsPage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/units" element={<UnitsPage />} />
              <Route path="/rules" element={<RulesPage />} />
              <Route path="/inconsistencies" element={<InconsistenciesPage />} />
              <Route path="/404" element={<NotFoundPage />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
